import { render, staticRenderFns } from "./IPause.vue?vue&type=template&id=5f355d6a&"
import script from "./IPause.vue?vue&type=script&lang=ts&"
export * from "./IPause.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports